import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LmsLearnerCourses from "@/routes/lms/lmsLearnerCourses";
import LmsAdminCoursesView from "@/routes/lms/lmsAdminCoursesView";
import { RootState } from "@/components/state/store";
import {
  getEffectiveLmsMode,
  getLmsCoursesRoute,
  LmsMode,
  shouldBlockLmsForSubdomain,
} from "@/components/lms/lms.utils";

interface Props {
  requiredMode?: LmsMode;
  redirectToEffectiveMode?: boolean;
}

export default function LmsCourses({
  requiredMode,
  redirectToEffectiveMode = false,
}: Props) {
  const loginState = useSelector((state: RootState) => state.login);

  const subdomain = window.location.hostname.split(".")[0];
  const shouldBlockLms = shouldBlockLmsForSubdomain({
    subdomain,
    permissions: loginState.permissions,
  });
  const effectiveMode = getEffectiveLmsMode({
    subdomain,
    permissions: loginState.permissions,
  });

  if (shouldBlockLms) {
    return <Navigate to="/" replace />;
  }

  if (redirectToEffectiveMode) {
    return <Navigate to={getLmsCoursesRoute(effectiveMode)} replace />;
  }

  if (requiredMode && effectiveMode !== requiredMode) {
    return <Navigate to={getLmsCoursesRoute(effectiveMode)} replace />;
  }

  if (effectiveMode === "learner") {
    return <LmsLearnerCourses requiredMode="learner" />;
  }

  return <LmsAdminCoursesView requiredMode={effectiveMode} />;
}
